import type { CountWallReview } from "./types";

export const countWallReview: CountWallReview = ({ walls, summary }) => ({
  walls: walls.filter((wall) => wall.kind === "wall").length,
  doors: walls.filter((wall) => wall.kind === "opening").length,
  changed: summary.removed + summary.drawn,
});
